module.exports = __webpack_public_path__ + "static/media/icon-interface.d96e8952.svg";